import React from 'react';

/**
 * Lazy-load operator remediation preview route only when internal controls are enabled (FR18).
 */
export function maybeRenderOperatorRemediationPreviewRoute(): React.ReactNode {
  if (process.env.REACT_APP_ENABLE_INTERNAL_CONTROLS !== 'true') {
    return null;
  }
  // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
  const Page = require('../pages/OperatorRemediationPreviewPage').default as React.ComponentType;
  return <Page />;
}
